import { useCallback } from "react";
const usePersonCounterSelect = (props)=>{
    const { selectedOptionIndex , onChange  } = props;
    const handleOnChange = useCallback((newValue)=>{
        onChange?.(selectedOptionIndex, newValue);
    }, [
        onChange,
        selectedOptionIndex
    ]);
    return {
        handleOnChange
    };
};
export default usePersonCounterSelect;

//# sourceMappingURL=usePersonCounterSelect.js.map